import { Typography } from "@material-ui/core"
import { FormattedMessage } from "react-intl"
import React, { memo } from "react";
import { FormFileInputContentProps } from "legacy-components/form/input/FormFileInput";
import { Form } from "react-final-form";


export interface ProductDocumentFieldFileInfo {
    id: string;
    fileInfo: any,
    loaded: boolean
    file?: File,
    openApiSpecId?: string;
    isNew?: boolean;
    publishedGateways?: any[]
}

interface FileUploaderProps {
    docInfo?: ProductDocumentFieldFileInfo,
}

const FileUploader = ({ openFileDialog }: FileUploaderProps & FormFileInputContentProps) => {

    return (
        <div onClick={openFileDialog}>
            <Typography variant="body2">
                    <span>
                        <FormattedMessage defaultMessage="Drag files here or " />
                        <span style={{ color: "#007bff", cursor: "pointer" }} >
                            <FormattedMessage defaultMessage="browse" />
                        </span>
                        <FormattedMessage defaultMessage=" to upload" />
                    </span>
            </Typography>
        </div>
    )
}

export default memo(FileUploader);